import React from "react";
import ReactTyped from "react-typed";
import { Navigation } from "./navigation";

export const Header = (props) => {
  return (
    
    <header id="header">
      <Navigation />
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                
                <h2>
                  
                  <span><ReactTyped strings={["Nosso destino é Inovar, <br/> a tecnologia é o caminho."]} typeSpeed={100} loop /></span>                  
                </h2>
                
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="#about"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Saiba mais 
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
